export default __webpack_public_path__ + "static/media/Fluxicon.bc5ffee2.png";